module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(!_vm.isConsultant) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('div', {
    staticClass: "header_margin"
  }, [(_vm.undertaking.undertakingId) ? _c('span', {
    staticStyle: {
      "width": "50px",
      "vertical-align": "middle"
    }
  }, [_c('router-link', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "to": {
        path: '/Undertaking/' + _vm.undertaking.undertakingId
      },
      "tag": "a"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Assigned Undertaking")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.undertaking.name ? _vm.undertaking.name : 'NOT YET ASSIGNED'))]), _vm._v(" "), (_vm.undertaking.undertakingId) ? [_c('span', {
    staticClass: "label"
  }, [_vm._v("DBU")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.undertaking.dbNumber))])] : _vm._e()], 2), _vm._v(" "), (_vm.undertaking.undertakingId) ? _c('div', [(_vm.undertaking.undertakingId) ? _c('span', {
    staticClass: "label"
  }, [_vm._v("Finding of Effect")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.undertaking.effectDescription))]), _vm._v(" "), (_vm.undertaking.undertakingId) ? _c('span', {
    staticClass: "label"
  }, [_vm._v("Review Framework")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.undertaking.reviewFrameworkDescription))]), _vm._v(" "), (_vm.undertaking.undertakingId) ? _c('span', {
    staticClass: "label"
  }, [_vm._v("Review Timeframe")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.undertaking.reviewTimeframeDescription))])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55e6681c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UndertakingHeader.vue
// module id = 943
// module chunks = 1